import GrafanaIcon from '@motional/inguitiv/svg/logo/grafana.svg?react';

function Icon() {
  return <GrafanaIcon />;
}

export default Icon;
